"use strict";

import {DB, initDB} from "../dbClass";
import axios from "axios";
import store from "@/store/index";
import router from "@/router/index";
import { errorFuncStruct, checkErrorCode } from './conectionUtils';

export interface CredentialLogin{
  username: string;
  password: string;
}

export interface UserData{
  nome: string;
  nivel: number;
  last_login: Date;
  itens_pag: number;
}

export function checkLogin(
  cb: (newLogin: CredentialLogin | null) => void
): void{
  let db: DB = store.getters.db;
  db = initDB(db);

  db.login.toCollection().first((value) => {
    let newLogin: null | CredentialLogin = null;
    if(value){
      newLogin = {
        username: value.user,
        password: value.password
      }
    }
    cb(newLogin);
  });
}


export function deleteLogin(
  cbOk: () => void,
  cbError: () => void
): void{
  let db: DB = store.getters.db;
  db = initDB(db);

  // TODO: SE CALHAR DESACTIVAR O TOKEN DA BD
  db.login.clear()
    .then(() => {
      cbOk();
    })
    .catch(() => {
      cbError()
    });
}

export function saveLogin(user: string, pass: string, cb: (value: number | boolean) => void | null ): void{
  let db: DB = store.getters.db;
  db = initDB(db);

  deleteLogin(
    () => {
      db.login.add({user: user, password: pass})
      .then((id: number) => {
        if(cb){
          cb(id);
        }
      })
      .catch(() => {
        // console.warn(error);
        if(cb){
          cb(false);
        }
      })
    },
    () => {
      if(cb){
        cb(false);
      }
    }
  )
  
}

export function loginServer(
  username: string,
  password: string,
  cbOk: () => void,
  cbError: errorFuncStruct
): void{
  const server = store.getters.configs.server;
  axios.post(server + "login.php", {user: username, pass: password})
    .then((response) => {
      if(response.data.token && response.data.user){
        const newCredential: CredentialLogin = {username: username as string, password: password};
        store.commit("setCredentials", newCredential);
        store.commit("setToken", response.data.token);
        store.commit("setUserData",response.data.user);
        cbOk();
      } else {
        cbError(response.data);
      }
    })
    .catch((error) => {
      cbError(checkErrorCode(error));
    })
}

export function logout(force = false): void {
  store.commit("setLoading",true);
  if(force){
    deleteLogin(
      () => {
        logout(false);
      },
      () => {
        store.commit("setError", {flag: true, text: "Ocorreu um erro a fazer o logout...", status: "error"});
        store.commit("setLoading",false);
        if(router.currentRoute.name != "Login"){
          router.push("/");
        }
      }
    )
  } else {
    store.commit("setToken", "");
    store.commit("setUserData", {});
    store.commit("setCredentials", {});
    store.commit("setLoading",false);
    if(router.currentRoute.name != "Login"){
      router.push("/");
    }
  }
  
}

export function refreshToken(cbOk: () => void): void{
  const username = store.getters.username;
  const password = store.getters.password;
  if(username && password){
    loginServer(
      username,
      password,
      cbOk,
      () => {
        logout(true);
      }
    );
  } else {
    logout(false);
  }
}
